import { useMediaQuery } from 'usehooks-ts'

type Breakpoint = 'base' | 'sm' | 'md' | 'lg' | 'xl' | '2xl'

const defaultBreakpoints: Record<Breakpoint, string> = {
	base: '(min-width: 0px)',
	sm: '(min-width: 480px)',
	md: '(min-width: 760px)', // Check --breakpoint-md
	lg: '(min-width: 992px)',
	xl: '(min-width: 1280px)',
	'2xl': '(min-width: 1440px)' // Check --breakpoint-2xl
}

export const useBreakpointValueWithoutSSR = <T>(
	values: Partial<Record<Breakpoint, T>> | Array<T | null>
): T | undefined => {
	const matchSm = useMediaQuery(defaultBreakpoints.sm, {
		// TODO: Change this to false for SSR in FE-3646
		// We can't change this right now due to a problems with zustand stores
		initializeWithValue: true
	})
	const matchMd = useMediaQuery(defaultBreakpoints.md, {
		// TODO: Change this to false for SSR in FE-3646
		// We can't change this right now due to a problems with zustand stores
		initializeWithValue: true
	})
	const matchLg = useMediaQuery(defaultBreakpoints.lg, {
		// TODO: Change this to false for SSR in FE-3646
		// We can't change this right now due to a problems with zustand stores
		initializeWithValue: true
	})
	const matchXl = useMediaQuery(defaultBreakpoints.xl, {
		// TODO: Change this to false for SSR in FE-3646
		// We can't change this right now due to a problems with zustand stores
		initializeWithValue: true
	})
	const match2xl = useMediaQuery(defaultBreakpoints['2xl'], {
		// TODO: Change this to false for SSR in FE-3646
		// We can't change this right now due to a problems with zustand stores
		initializeWithValue: true
	})

	const breakpoints = [
		{ key: '2xl', matches: match2xl },
		{ key: 'xl', matches: matchXl },
		{ key: 'lg', matches: matchLg },
		{ key: 'md', matches: matchMd },
		{ key: 'sm', matches: matchSm },
		{ key: 'base', matches: true }
	]

	for (let i = 0; i < breakpoints.length; i++) {
		if (breakpoints[i].matches) {
			if (
				!Array.isArray(values) &&
				!Object.keys(values).includes(breakpoints[i].key)
			) {
				continue
			}

			return Array.isArray(values)
				? (values[i] ?? undefined)
				: values[breakpoints[i].key as Breakpoint]
		}
	}

	return undefined
}
